import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Text } from 'components/ui';
import { radii, space } from 'style/config';

const RECOMMENDATION_BUCKET_ID = 'personalization';
const RECOMMENDATION_SIGNAL_ID = 'explicit_preferences';
const BESTSELLER_SIGNAL_ID = 'bestseller';
const MAX_TAGS = 2;

const TAG_COLORS = {
    green: '#E2F4E7',
    gray: '#F0F0F0'
};

const containerStyles = {
    display: 'flex',
    flexWrap: 'wrap',
    gap: `${space[1]}px`,
    marginTop: '9px'
};

const tagBaseStyles = {
    display: 'inline-flex',
    alignItems: 'center',
    height: '16px',
    padding: `0 ${space[1]}px`,
    borderRadius: `${radii[2]}px`,
    whiteSpace: 'nowrap',
    textAlign: 'center'
};

function getTagBackgroundColor(bucketId, signalId) {
    if (bucketId === RECOMMENDATION_BUCKET_ID && signalId === RECOMMENDATION_SIGNAL_ID) {
        return TAG_COLORS.green;
    }

    return TAG_COLORS.gray;
}

function filterTags(explainabilityTags) {
    if (!explainabilityTags?.length) {
        return [];
    }

    return explainabilityTags.filter(tag => tag.signalId !== BESTSELLER_SIGNAL_ID).slice(0, MAX_TAGS);
}

function MlRecommendationTag({ explainabilityTags }) {
    const tags = filterTags(explainabilityTags);

    if (!tags.length) {
        return null;
    }

    return (
        <div css={containerStyles}>
            {tags.map(tagData => (
                <Text
                    key={`${tagData.bucketId}-${tagData.signalId}-${tagData.tag}`}
                    is='span'
                    fontSize='11px'
                    lineHeight='14px'
                    color='black'
                    backgroundColor={getTagBackgroundColor(tagData.bucketId, tagData.signalId)}
                    baseCss={tagBaseStyles}
                    data-at={Sephora.debug.dataAt('ml_recommendation_tag')}
                    children={tagData.tag}
                />
            ))}
        </div>
    );
}

MlRecommendationTag.shouldUpdatePropsOn = ['explainabilityTags'];

export { BESTSELLER_SIGNAL_ID };

export default wrapFunctionalComponent(MlRecommendationTag, 'MlRecommendationTag');
